import CessionsController from './cessions.controller';
import Template from './cessions.tpl.html';

export default {
	template: Template,
	controller: CessionsController
};
